"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable: variable-name no-shadowed-variable max-line-length */
var N = [
    NaN,
    0.118160747229, 0.713116392079, -0.161824192067e1, 0.714140178971e-1, -0.865421396646e-1, 0.134211176704,
    0.112626704218e-1, -0.420533228842e-1, 0.349008431982e-1, 0.164957183186e-3, -0.101365037912,
    -0.173813690970, -0.472103183731e-1, -0.122523554253e-1, -0.146629609713, -0.316055879821e-1,
    0.233594806142e-3, 0.148287891978e-1, -0.938782884667e-2,
];
var i = [Number.MIN_VALUE, 1, 1, 1, 2, 3, 3, 4, 4, 4, 6, 1, 3, 5, 6, 1, 3, 11, 1, 3];
var j = [
    NaN,
    0, 0.33, 1.01, 0, 0, 0.15, 0, 0.2, 0.35, 1.35, 1.6, 0.8,
    0.95, 1.25, 3.6, 6, 3.25, 3.5, 15,
];
var l = [Number.MIN_VALUE, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 3, 3];
/// <param name="T">Temperature [K] </param>
/// <returns>[kJ/kmol]</returns>
function Get_Ideal_Gas_Molar_Enthalpy_of_Dry_Air(T) {
    //double rho_j = 10.4477 * (10 * 10 * 10); // [mol/dm3] -> [mol/m3]
    //double delta = 1 / (v_bar * rho_j);
    var T_j = 132.6312; // [K]̅
    var tau = T_j / T;
    var hbar0Lem = -7914.149298; // [kJ/kmol] = [J/mol]
    var RbarLem = 8.314510; // [kJ/(kmol K)] = [J/(mol K)]
    var dalphao_dtau_delta = Get_dalphao_dtau_delta(tau);
    var hbaro_a = hbar0Lem + RbarLem * T * (1 + tau * dalphao_dtau_delta);
    return hbaro_a;
}
exports.Get_Ideal_Gas_Molar_Enthalpy_of_Dry_Air = Get_Ideal_Gas_Molar_Enthalpy_of_Dry_Air;
function Get_dalphao_dtau_delta(tau) {
    var No = [
        NaN,
        0.605719400E-7, -0.210274769E-4, -0.158860716E-3, -0.13841928076E2, 0.17275266575E2, -0.195363420E-3,
        0.2490888032E1, 0.791309509, 0.212236768, -0.197938904, 0.2536365E2, 0.1690741E2, 0.8731279E2,
    ];
    var dalphao_dtau_delta = 0;
    for (var i_1 = 1; i_1 <= 5; i_1++) {
        dalphao_dtau_delta += (i_1 - 4) * No[i_1] * Math.pow(tau, i_1 - 5);
    }
    dalphao_dtau_delta += 1.5 * No[6] * Math.pow(tau, 0.5) + No[7] * Math.pow(tau, -1);
    dalphao_dtau_delta += (No[8] * No[11]) / (Math.exp(No[11] * tau) - 1) + ((No[9] * No[12]) / (Math.exp(No[12] * tau) - 1));
    dalphao_dtau_delta += ((No[10] * No[13]) / ((2.0 / 3.0) * Math.exp(-No[13] * tau) + 1));
    return dalphao_dtau_delta;
}
function Get_d3alphar_ddelta2_dtau(delta, tau) {
    var d3aplhar_ddelta2_dtau = 0;
    for (var k = 1; k <= 10; k++) {
        d3aplhar_ddelta2_dtau += i[k] * (i[k] - 1) * j[k] * N[k] * Math.pow(delta, i[k] - 2) * Math.pow(tau, j[k] - 1);
    }
    for (var k = 11; k <= 19; k++) {
        d3aplhar_ddelta2_dtau += j[k] * N[k] * Math.pow(delta, i[k] - 2) * Math.pow(tau, j[k] - 1) * Math.exp(-Math.pow(delta, l[k])) * ((i[k] - l[k] * Math.pow(delta, l[k])) * (i[k] - 1 - l[k] * Math.pow(delta, l[k])) - Math.pow(l[k], 2) * Math.pow(delta, l[k]));
    }
    return d3aplhar_ddelta2_dtau;
}
exports.Get_d3alphar_ddelta2_dtau = Get_d3alphar_ddelta2_dtau;
function Get_d2alphar_ddelta_dtau(delta, tau) {
    var d2alphar_ddelta_dtau = 0;
    for (var k = 1; k <= 10; k++) {
        d2alphar_ddelta_dtau += i[k] * j[k] * N[k] * Math.pow(delta, i[k] - 1) * Math.pow(tau, j[k] - 1);
    }
    for (var k = 11; k <= 19; k++) {
        d2alphar_ddelta_dtau += j[k] * N[k] * Math.pow(delta, i[k] - 1) * Math.pow(tau, j[k] - 1) * Math.exp(-Math.pow(delta, l[k])) * (i[k] - l[k] * Math.pow(delta, l[k]));
    }
    return d2alphar_ddelta_dtau;
}
exports.Get_d2alphar_ddelta_dtau = Get_d2alphar_ddelta_dtau;
function Get_dalphar_dDelta(delta, tau) {
    var dalphar_dDelta = 0;
    for (var k = 1; k <= 10; k++) {
        dalphar_dDelta += i[k] * N[k] * Math.pow(delta, (i[k] - 1)) * Math.pow(tau, j[k]);
    }
    for (var k = 11; k <= 19; k++) {
        dalphar_dDelta += N[k] * Math.pow(delta, i[k] - 1) * Math.pow(tau, j[k]) * Math.exp(Math.pow(-delta, l[k])) *
            (i[k] - l[k] * Math.pow(delta, l[k]));
    }
    return dalphar_dDelta;
}
exports.Get_dalphar_dDelta = Get_dalphar_dDelta;
function Get_d2alphar_dDelta2(delta, tau) {
    var d2alphar_dDelta2 = 0;
    for (var k = 1; k <= 10; k++) {
        d2alphar_dDelta2 += i[k] * (i[k] - 1.0) * N[k] * Math.pow(delta, (i[k] - 2.0)) * Math.pow(tau, j[k]);
    }
    for (var k = 11; k <= 19; k++) {
        d2alphar_dDelta2 += N[k] * Math.pow(delta, i[k] - 2.0) * Math.pow(tau, j[k]) * Math.exp(-Math.pow(delta, l[k])) *
            ((i[k] - l[k] * Math.pow(delta, l[k])) * (i[k] - 1.0 - l[k] * Math.pow(delta, l[k])) -
                Math.pow(l[k], 2) * Math.pow(delta, l[k]));
    }
    return d2alphar_dDelta2;
}
exports.Get_d2alphar_dDelta2 = Get_d2alphar_dDelta2;
